import { SESSION_KEY } from './reducers';

export const getSessionId = state => state.getIn([SESSION_KEY, 'sessionId']);
export const getSessionType = state => state.getIn([SESSION_KEY, 'sessionType']);
export const getSessionStatus = state => state.getIn([SESSION_KEY, 'sessionStatus']);

/**
 * Determine from the state whether a student is logged into a session
 * @param state
 * @returns {boolean}
 */
export const isInStudentSession = state => !!getSessionId(state);

export const getVideosDisabled = state =>
    getSessionType(state) === 'lesson' &&
    state.getIn([SESSION_KEY, 'lessonSettings', 'disableVideosByDefault']) &&
    state.getIn([SESSION_KEY, 'sessionVideoStatus']) !== 'VIDEO_STATUS_ENABLED';

export const getLessonDeliveryId = state => state.getIn([SESSION_KEY, 'lessonDeliveryId']);

export const getLessonJoinCode = state => state.getIn([SESSION_KEY, 'lessonJoinCode']);
